import { Tooltip, Space, Button, Typography } from "antd";
// import { Image } from "antd";
// import { PrinterOutlined, QuestionCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { EditOutlined, MenuOutlined, EyeOutlined } from "@ant-design/icons";
import {
  EditableRow,
  EditableCell,
  RowDrag,
} from "../../../components/table/TableEditAble";
import { formatCommaNumber } from "../../../utils/util";
import { TagDocRuncode } from "../../../components/badge-and-tag/ERP";
import { TagItemTypes } from "../../../components/badge-and-tag/ERP";
import dayjs from "dayjs";
import { docLinkRender } from "../../../components/table/DocLink";
export const componentsEditable = {
  body: { row: EditableRow, cell: EditableCell },
};

export const componentsDraggableEditable = {
  body: { row: RowDrag, cell: EditableCell },
};

const dragColumn = {
  title: "",
  dataIndex: "sort",
  key: "sort",
  width: 44,
  align: "center",
  className: "drag-visible",
  render: () => <MenuOutlined style={{ color: "#9ca3af", cursor: "grab" }} />,
};

export const accessColumn = ({ handleEdit, handleDelete, handleView }) => [
  {
    key: "id",
    dataIndex: "id",
    align: "left",
    hidden: true,
  },
  {
    title: "รหัสสินค้า",
    dataIndex: "product_code",
    key: "product_code",
    sorter: (a, b) =>
      (a?.product_code || "").localeCompare(b?.product_code || ""),
    width: 140,
    /* กดเลขที่เอกสารเพื่อเปิดหน้าแสดงข้อมูล */
    render: docLinkRender(handleView, "เปิดดู BOM"),
  },
  {
    title: "ชื่อสินค้า",
    dataIndex: "product_name",
    key: "product_name",
    width: "25%",
    sorter: (a, b) =>
      (a?.product_name || "").localeCompare(b?.product_name || ""),
    ellipsis: { showTitle: false },
    render: (v) => (
      <Tooltip placement="topLeft" title={v}>
        {v}
      </Tooltip>
    ),
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
    sorter: (a, b) => (a?.code || "").localeCompare(b?.code || ""),
    width: 140,
  },
  {
    title: "ประเภทสินค้า",
    dataIndex: "product_type",
    key: "product_type",
    sorter: (a, b) =>
      (a?.product_type || "").localeCompare(b?.product_type || ""),
    width: 140,
    sortDirections: ["descend", "ascend"],
    render: (data) => <TagDocRuncode result={data} />,
  },
  {
    title: "จำนวนส่วนผสม",
    dataIndex: "bom_qty",
    key: "bom_qty",
    sorter: (a, b) => (a?.bom_qty || 0) - (b?.bom_qty || 0),
    width: 140,
  },
  {
    title: "อัพเดทล่าสุด",
    dataIndex: "updated_date",
    key: "updated_date",
    width: "10%",
    sorter: (a, b) =>
      (a?.updated_date || "").localeCompare(b?.updated_date || ""),
    render: (_, head) =>
      head?.updated_date ? dayjs(head.updated_date).format("DD/MM/YYYY") : "",
  },
  {
    title: "Action",
    key: "operation",
    width: "100px",
    fixed: "right",
    render: (text, record) => (
      <Space>
        <Button
          size="small"
          icon={<EyeOutlined />}
          className="bn-success-outline"
          title="ดูข้อมูล"
          onClick={() => handleView(record)}
        />
        <Button
          icon={<EditOutlined />}
          className="bn-primary-outline"
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => handleEdit(record)}
          size="small"
        />
      </Space>
    ),
  },
];

export const detailColumns = ({ handleAction }) => {
  return [
    dragColumn,
    {
      title: "No.",
      key: "seq",
      dataIndex: "seq",
      align: "left",
      width: 50,
      // render: (_, record, idx) => <span key={record?.code}>{idx + 1}</span>,
    },
    {
      title: "Code",
      align: "left",
      width: 180,
      key: "mat_code",
      dataIndex: "mat_code",
      editable: true,
      required: false,
      type: "modal-select",
      className: "field-edits pe-2",
      /* แถวที่ดึงมาจาก Sample Preparation แล้วไม่มีรหัสนี้ใน ERP จะยังไม่มี mat_code
         แสดงคำชี้แนะให้กดช่องนี้เพื่อเลือกวัตถุดิบ ERP มาทดแทน */
      render: (v, record) =>
        v ? (
          v
        ) : record?.rd_unmatched ? (
          <Typography.Text type="danger">กดเพื่อเลือกวัตถุดิบ</Typography.Text>
        ) : (
          ""
        ),
    },
    {
      title: "ชื่อวัตุดิบ",
      key: "mat_name",
      dataIndex: "mat_name",
      /* ยังไม่ได้เลือกตัวทดแทน -> โชว์ชื่อต้นทางจาก Sample Preparation ไว้อ้างอิง */
      render: (v, record) =>
        v ? (
          v
        ) : record?.rd_unmatched ? (
          <Tooltip title={`มาจาก Sample Preparation รหัส ${record?.rd_code || "-"}`}>
            <Typography.Text type="secondary">
              (SP) {record?.rd_name || record?.rd_code || "-"}
            </Typography.Text>
          </Tooltip>
        ) : (
          ""
        ),
    },
    {
      title: "น้ำหนักตัดแต่งแล้ว(g)",
      key: "qty",
      dataIndex: "qty",
      editable: true,
      required: true,
      align: "right",
      width: 120,
      className: "field-edit pe-2",
      render: (v) => formatCommaNumber(Number(v || 0),2,2),
    },
    {
      title: "น้ำหนักวัตถุดิบสด(g)",
      key: "qty_after_lost",
      dataIndex: "qty_after_lost",
      align: "right",
      width: 120,
      className: "field-edit pe-2",
      render: (v) => formatCommaNumber(Number(v || 0),2,2),
      // render: (v, data) =>
      //   formatCommaNumber(Number(data.qty /(data.yield/ 100)  || 0),2,2),
    },
    {
      title: "%",
      align: "right",
        width: 60,
      className: "pe-2",
      key: "percent",
      dataIndex: "percent",
      render: (v) => formatCommaNumber(Number(v || 0), 2, 2),
    },
    {
      title: "%(total)",
      align: "right",
      width: 60,
      className: "pe-2",
      key: "totalpercent",
      dataIndex: "totalpercent",
      render: (v, record, idx) =>
        v !== null ? formatCommaNumber(Number(v), 2, 2) : "",
    },
    {
      title: "Multiply",
      align: "right",
      width: 60,
      className: "pe-2",
      editable: true,
      required: false,
      key: "multiply",
      dataIndex: "multiply",
      render: (v, record, idx) => formatCommaNumber(Number(v || 0)),
    },
    {
      title: "Wt.in process",
      align: "right",
      width: 60,
      className: "pe-2",
      key: "wt_in_process",
      dataIndex: "wt_in_process",
      render: (v, record, idx) => formatCommaNumber(Number(v || 0)),
      // render: (v, record, idx) => {
      //   const weight_in =
      //     Number(record?.qty || 0) * Number(record?.multiply || 0);
      //   return formatCommaNumber(Number(weight_in || 0), 2, 2);
      // },
    },
    {
      title: "Yield",
      align: "right",
      width: 60,
      editable: true,
      required: false,
      className: "pe-2",
      key: "yield",
      dataIndex: "yield",
      render: (v, record, idx) => `${formatCommaNumber(Number(v || 0))} %`,
    },
    {
      title: "Method",
      align: "left",
      key: "method",
      dataIndex: "method",
      editable: true,
      required: false,
      // textArea: true,
      className: "field-edit ps-2",
      width: 180,
    },
    {
      title: "ตัวเลือก",
      align: "center",
      key: "operation",
      dataIndex: "operation",
      render: (_, record, idx) => handleAction(record),
      width: "90px",
      fixed: "right",
    },
  ].filter((item) => !item.hidden);
};

/** get column for edit table parameter */
export const pkColumns = ({ handleActionPK }) => {
  return [
    dragColumn,
    {
      title: "No.",
      key: "seq",
      dataIndex: "seq",
      align: "left",
      width: 50,
      // render: (_, record, idx) => <span key={record?.code}>{idx + 1}</span>,
    },
    {
      title: "รหัสบรรจุภัณฑ์",
      key: "pk_code",
      dataIndex: "pk_code",
    },
    {
      title: "ชื่อบรรจุภัณฑ์",
      key: "pk_name",
      dataIndex: "pk_name",
    },
    {
      title: "ชนิดบรรจุภัณฑ์",
      dataIndex: "typename",
      key: "typename",
      width: 140,
      sortDirections: ["descend", "ascend"],
      render: (data) => <TagItemTypes data={data} />,
    },
    {
      title: "จำนวน",
      key: "qty",
      dataIndex: "qty",
      editable: true,
      required: true,
      align: "right",
      width: 120,
      className: "field-edit pe-2",
      render: (v) => formatCommaNumber(Number(v || 0)),
    },
    {
      title: "Method",
      align: "left",
      key: "method",
      dataIndex: "method",
      editable: true,
      required: false,
      className: "field-edit ps-2",
      width: 180,
    },
    {
      title: "ตัวเลือก",
      align: "center",
      key: "operation",
      dataIndex: "operation",
      render: (_, record, idx) => handleActionPK(record),
      width: "90px",
      fixed: "right",
    },
  ].filter((item) => !item.hidden);
};

export const columnsDetailsEditable = (
  handleSave,
  handleModalSelect,
  { handleAction, nameOption }
) => {
  const col = detailColumns({ handleAction, nameOption });
  return col.map((col, ind) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => {
        // console.log(record);
        return {
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave,
          fieldType: !!col?.textArea,
          required: !!col?.required,
          type: col?.type || "input",
          autocompleteOption: col.autocompleteOption,
          modalSelect: handleModalSelect,
        };
      },
    };
  });
};

export const columnsPKEditable = (
  handleSave,
  handleModalSelect,
  { handleActionPK, nameOption }
) => {
  const col = pkColumns({ handleActionPK, nameOption });
  return col.map((col, ind) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => {
        // console.log(record);
        return {
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave,
          fieldType: !!col?.textArea,
          required: !!col?.required,
          type: col?.type || "input",
          autocompleteOption: col.autocompleteOption,
          modalSelect: handleModalSelect,
        };
      },
    };
  });
};

export const PG = {
  id: null,
  product_code: null,
  product_name: null,
  pg_type: null,
  sample_ref: null,
  code: null,
  unit: null,
  weight_nw: 0,
  weight_gw: 0,
  feature: null,
  remarks: null,
  active_status: null,
};
